import { Button, Stack, Typography, Divider } from '@mui/material'
import PageWrapper from 'hoc/PageWrapper'
import { useBoolean } from 'hooks/useBoolean'
import { useTranslation } from 'react-i18next'
import { DialogCreateVideo } from './dialog-create-video'
import { VideoInstructionsList } from './video-instructions-list'
import { useQueryState } from 'react-router-use-location-state'

export const VideoInstructions = () => {
  const { t } = useTranslation()
  const dialogCreateVideo = useBoolean(false)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_page, setPage] = useQueryState('page', 0)

  return (
    <PageWrapper>
      {dialogCreateVideo.isTrue && (
        <DialogCreateVideo onClose={dialogCreateVideo.setFalse} />
      )}
      <Stack spacing={3}>
        <Stack alignItems="center" direction="row" justifyContent="space-between">
          <Typography fontWeight="bold" variant="h6">
            {t('videoInstructions')}
          </Typography>
          <Button
            onClick={dialogCreateVideo.setTrue}
            variant="contained"
            style={{ color: '#fff', backgroundColor: 'rgb(3, 34, 76)' }}
          >
            {t('createNew')}
          </Button>
        </Stack>
        <Divider sx={{ my: 1.5 }} />

        <VideoInstructionsList />
      </Stack>
    </PageWrapper>
  )
}
